export default __webpack_public_path__ + "static/playCircle-b530fd242c5a2e24b8258b0e8c39875e.png";